import React from 'react';
import { HStack } from '@chakra-ui/react';

const SliderPagination = () => (
  <HStack
    className="pagination"
    spacing="3"
    justifyContent="center"
    sx={{
      '.swiper-pagination-bullet': {
        display: `block`,
        width: 3,
        height: 3,
        minWidth: `12px`,
        minHeight: `12px`,
        background: `transparent`,
        border: `2px`,
        borderColor: `milka.primary.dark-purple`,
        borderRadius: `100%`,
        cursor: `pointer`,
        transition: `.3s ease-in-out`
      },
      '.swiper-pagination-bullet:hover': {
        background: `milka.primary.dark-purple`
      },
      '.swiper-pagination-bullet-active': {
        background: `milka.primary.dark-purple`
      }
    }}
  />
);

export default SliderPagination;
